"use strict";
import { createEffect, createResource, useContext } from "solid-js";
import { access } from "@solid-primitives/utils";
import { RepoContext } from "./context.js";
const readyStates = ["ready", "deleted", "unavailable"];
const badStates = ["deleted", "unavailable"];
export default function useDocHandle(url, options) {
  const contextRepo = useContext(RepoContext);
  if (!options?.repo && !contextRepo) {
    throw new Error("use outside <RepoContext> requires options.repo");
  }
  const repo = options?.repo || contextRepo;
  function getExistingHandle() {
    if (options?.["~skipInitialValue"]) return void 0;
    const unwrappedURL = access(url);
    if (!unwrappedURL) return void 0;
    try {
      const documentId = new URL(unwrappedURL).pathname;
      const existingHandle = repo.handles[documentId];
      if (existingHandle?.isReady()) {
        return existingHandle;
      }
    } catch (error) {
      console.error("Error parsing URL:", error);
    }
  }
  const [handle, { mutate }] = createResource(
    url,
    async (url2) => {
      const handle2 = await repo.find(url2, {
        allowableStates: readyStates
      });
      const reject = (state) => Promise.reject(new Error(`document not available: [${state}]`));
      if (handle2.isReady()) {
        return handle2;
      } else if (handle2.inState(badStates)) {
        return reject(handle2.state);
      }
      return handle2.whenReady(readyStates).then(() => {
        if (handle2.isReady()) {
          return handle2;
        }
        return reject(handle2.state);
      });
    },
    {
      initialValue: getExistingHandle()
    }
  );
  createEffect(() => {
    if (!access(url)) {
      mutate();
    }
  });
  return handle;
}
//# sourceMappingURL=useDocHandle.js.map
